import type { FrontBannerV2PageConfig, FrontBannerV2Payload } from "@/lib/api/frontBanner";

export const normalizeBannerSlug = (value: string) =>
	value
		.trim()
		.replace(/^\/+|\/+$/g, "")
		.replace(/\/{2,}/g, "/")
		.toLowerCase();

export const buildBannerSlugCandidates = (pageSlug: string) => {
	const normalizedSlug = normalizeBannerSlug(pageSlug);

	if (!normalizedSlug || normalizedSlug === "home" || normalizedSlug === "index") {
		return ["home"];
	}

	const parts = normalizedSlug.split("/").filter(Boolean);
	const candidates = [normalizedSlug];

	if (parts.length > 1) {
		candidates.push(parts[0]);
	}

	return Array.from(new Set(candidates));
};

export const matchFrontBannerPageConfig = (
	payload: FrontBannerV2Payload | null | undefined,
	pageSlug: string,
): FrontBannerV2PageConfig | null => {
	if (!payload?.page_configs?.length) {
		return null;
	}

	const slugCandidates = buildBannerSlugCandidates(pageSlug);
	if (slugCandidates.length === 0) {
		return null;
	}

	const configMap = new Map(
		payload.page_configs.map((pageConfig) => [normalizeBannerSlug(pageConfig.slug), pageConfig] as const),
	);

	for (const candidate of slugCandidates) {
		const matchedConfig = configMap.get(candidate);
		if (matchedConfig) {
			return matchedConfig;
		}
	}

	return null;
};
